// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.0001 2L13.0001 22H11.0001L11.0001 2L13.0001 2ZM9.00005 4.64087V18.5H1.30054L9.00005 4.64087ZM15.0001 4.64087L22.6996 18.5H15.0001V4.64087Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mirror-filled')
export default class MirrorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mirror-filled',
    }
  }
}
